<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目ID：" prop="pid1">
                <span>{{model.pid1}}</span>
            </el-form-item>
            <el-form-item label="设备种类：" prop="device_type">
                <span>{{model.device_type}}</span>
            </el-form-item>
            <el-form-item label="设备数量：" prop="device_count">
                <span>{{model.device_count}}</span>
            </el-form-item>
            <el-form-item label="所需设备数量：" prop="device_count_need">
                <span>{{model.device_count_need}}</span>
            </el-form-item>
            <el-form-item label="数量差：" prop="device_count_cha">
                <span>{{model.device_count_cha}}</span>
            </el-form-item>
            <el-form-item label="投入使用数量：" prop="device_count_use">
                <span>{{model.device_count_use}}</span>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="添加人ID：" prop="creator_id">
                <span>{{model.creator_id}}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人ID：" prop="update_id">
                <span>{{model.update_id}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceInfoInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                device_type: '',
                device_count: '',
                device_count_need: '',
                device_count_cha: '',
                device_count_use: '',
                order_index: '',
                remark: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/deviceinfo/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>